// The fixed ARIA value range: `value` is applied directly as a CSS `%`, so
// the scale can only ever be 0-100 — see progress.ts.
export const RANGE = Object.freeze({
  MIN: '0',
  MAX: '100',
})
